import AbsSection from './AbsSection';

export default class SecTheme extends AbsSection {
    constructor(_container='', _dataM={}, _option={}){
        super(_container, _dataM, _option, 'theme');
        if( this.isShow ){
            this.dataM.addCall(this.alias, {path: "/v1/videos/main?" + $.param({videoIds: _option.manualDataIds.join()})});
        }
        
    }

    setTemplate(){
        const cardData = this.dataM.data.theme;
        const html = this.getHtml(cardData);

        $(this.container).css('background-image',`url(' ${this.option.bgImage}')`).append(html); 

        this.sl = $(this.container + ' .main-theme-list').slick({
            dots: false, arrows: true, infinite: false,
            speed: 600, slidesToScroll: 1,
            prevArrow: $('.main-theme-arrow.is-prev'),
            nextArrow: $('.main-theme-arrow.is-next'),
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        prevArrow: '',
                        nextArrow: '',
                        arrows: false,
                        slidesToShow: 1
                    }
                }
            ]
        });
        this.setAni();
        this.addEvents();
    }

    getHtml(_d){
        const items = _d.map( this.getItem ).join('');
        return `<div class="main-theme-inner">
            <div class="main-theme-header">
                <h2 class="main-theme-title">${this.option.title}</h2>
                <p class="main-theme-desc">${this.option.desc}</p>
                <span class="main-theme-arrow is-prev">${require('../../svg/arrow.svg')}</span>
                <span class="main-theme-arrow is-next">${require('../../svg/arrow.svg')}</span>
            </div>
            <!-- 목록  -->
            <ul class="main-theme-list">
                ${items}
            </ul>
            <!-- //목록  -->
        </div>`
    }

    getItem(_d){
        return `<li class="item">
            <div class="card card-thumbnail is-center">
                <div class="card-container">
                    <div class="card-header">
                        <a href="/view?tv=${_d.gameAlias}&id=${_d.id}&from=popular">
                            <div class="card-header-thumb">
                                <div class="thumb-img" style="background-image: url(${_d.thumbnail});">${_d.title}</div>
                            </div>
                        </a>
                    </div>
                    <div class="card-body">
                        <div class="card-content">
                            <div class="card-content-title"><a href="/view?tv=${_d.gameAlias}&id=${_d.id}&from=popular">${_d.title}</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </li>`
    }

    setAni(){
        const offsetTop = $(this.container).offset().top;
        const ScrollTop = $(window).scrollTop();
        const height = $(this.container).height();

        if( height * 1.5 + ScrollTop > offsetTop) $(this.container).addClass('is-active')
        else $(this.container).removeClass('is-active');
    }

    setEvents(){
        $(window).scroll((e) => this.setAni()) 
    }



} // end of class
